import { Component } from '@angular/core';
import {BaseModalComponent} from "common-shared";

@Component({
  selector: 'app-confirm-final-modification-modal',
  templateUrl: './confirm-final-modification-modal.component.html',
  styles: [
  ]
})
export class ConfirmFinalModificationModalComponent extends BaseModalComponent {

}
